/* global modForm */
import { getDefaultSiteByDomain } from '../helpers';
/**
 * Check if current domain is eligible for HRC
 *
 * @returns {Boolean} - true if domain is eligible for HRC
 */
export function isQsSiteEligibleForHrc() {
	const eligibleDomains = [
		'modernize.local',
		'modernize.com',
		'roofing-survey.com',
		'thesidingremodelconnection.com',
		'windowscostguide.com',
		'windowspromos.com',
		'windowssurvey.com'
	];

	if (modForm.opts.isEligibleForHrc) {
		return true;
	}

	return eligibleDomains.indexOf(getDefaultSiteByDomain()) > -1;
}
